import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

/**
 * How an edit of a recurring restriction should be applied:
 * - THIS_OCCURRENCE: only the selected occurrence (it becomes a detached one-time restriction);
 * - FROM_SELECTED_DATE: the series restarts from the selected date with the new settings;
 * - ALL_OCCURRENCES: the whole series is updated in place, keeping its original start date.
 */
export type ModifyScope = 'THIS_OCCURRENCE' | 'FROM_SELECTED_DATE' | 'ALL_OCCURRENCES';

export interface ModifyScopeDialogData {
  title?: string;
  message?: string;
  restrictionName?: string;
  selectedDate?: Date;
  // Hidden when the edit cannot apply to a single occurrence (e.g. only the repeat days changed).
  showThisOccurrence?: boolean;
}

export interface ModifyScopeDialogResult {
  scope: ModifyScope;
}

@Component({
  selector: "app-modify-scope-dialog",
  templateUrl: "./modify-scope-dialog.component.html",
  styleUrl: "./modify-scope-dialog.component.scss",
  standalone: false,
})
export class ModifyScopeDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ModifyScopeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ModifyScopeDialogData
  ) {
    // Set default values if not provided
    if (!this.data.title) {
      this.data.title = 'Modify Restriction';
    }
    if (!this.data.message) {
      this.data.message = 'How would you like to apply these changes?';
    }
  }

  get selectedDateLabel(): string {
    return this.data.selectedDate ? this.data.selectedDate.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' }) : 'the selected date';
  }

  onSelectScope(scope: ModifyScope): void {
    this.dialogRef.close({ scope });
  }

  onCancel(): void {
    this.dialogRef.close(null);
  }
}
